import React, { Component } from 'react'
import Quagga from 'quagga'
import "../styles.css"


class Scanner extends Component {
    componentDidMount() {
        Quagga.init(
            {
                inputStream : {
                    name : "Live",
                    type : "LiveStream",
                    target: document.querySelector('#interactive') ,  // Or '#yourElement' (optional)
                    area: { // defines rectangle of the detection/localization area
                        top: "0%",    // top offset
                        right: "0%",  // right offset
                        left: "0%",   // left offset
                        bottom: "0%"  // bottom offset
                    },
                },
                decoder : {
                    readers : ["code_128_reader"]
                },
                locator: {
                    patchSize: 'medium',
                    halfSample: true,
                },
                locate: true
            }, function(err) {
                if (err) {
                    console.log(err);
                    return
                }
                Quagga.start();
        });
        Quagga.onDetected(this._onDetected)

    }

    componentWillUnmount() {
        Quagga.offDetected(this._onDetected)
    }

    _onDetected = result => {
        this.props.onDetected(result)
    }


render() {
        return(
            <div id="interactive" className="viewport"/>
        )
    }
}


export default Scanner